import { useContext, useState, useEffect } from 'react';

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';

import PD_BaseListComponent from '../PD_BaseListComponent';
import PD_ConferenceComponent from './PD_ConferenceComponent';
import DarkButtonComponent from '../../commons/DarkButtonComponent';


const PD_ConferenceListComponent = () => {

    const { language, selectedProject, currentUser } = useContext(GlobalContext);
    const { setCreateConference, setCreateMeeting, setCreateNewPresentation } = useContext(ProjectDetailsContext)

    const [sortedConferences, setSortedConferences] = useState(selectedProject.conferences.sort((a, b) => new Date(b.scheduleDate) - new Date(a.scheduleDate)))

    const confStyle = {
        border: "2px solid #33FFC8",
        borderRadius: "8px",
        backdropFilter: "blur(31px)",
        width: "auto",
        height: "78px",
        padding: "0px 40px",
        marginRight: 29,
        marginBottom: 57
    }

    useEffect(() => {
        setSortedConferences(selectedProject.conferences.sort((a, b) => new Date(b.scheduleDate) - new Date(a.scheduleDate)))
    }, [selectedProject])


    return (

        <PD_BaseListComponent
            title={language.project_details.Conferences}
            marginLeft={2}
            list={sortedConferences?.map((conference) => (
                <PD_ConferenceComponent key={conference._id} conference={conference} />
            ))}
            button={
                <div>
                    {currentUser?.function?.code === "ADMN" || currentUser?.role.toLowerCase() === "administrator" &&
                        <>
                            <DarkButtonComponent onClick={() => setCreateConference(true)} style={confStyle}>
                                {/* <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['keynote']} /> */}
                                Add conference
                            </DarkButtonComponent>
                            <DarkButtonComponent onClick={() => setCreateMeeting(true)} style={confStyle}>
                                {/* <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['users-rectangle']} /> */}
                                Add meeting
                            </DarkButtonComponent>

                            <DarkButtonComponent onClick={() => setCreateNewPresentation(true)} style={confStyle}>
                                {/* <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['users-rectangle']} /> */}
                                Add presentation
                            </DarkButtonComponent>
                        </>
                    }

                </div>

            }
        />

    );

}

export default PD_ConferenceListComponent;